import { getMaxPollOptionValue } from '../../../utils/poll-utils';
import styles from './ProjectPolls.module.less';
import ProjectPollOption from './ProjectPollOption';
import { useProject } from '../../project-hooks/useProject';
import { isActive, isPublished, isStartingInTheFuture } from '../../project-model';
import { Heading1, SmallText } from '@sb1/ffe-core-react';

const ProjectPoll = ({ poll }) => {
    const project = useProject();
    const max = getMaxPollOptionValue({ poll });
    const endedMessage = poll.stopped_at ? 'Avsluttet' : '';
    const startingInTheFuture = isStartingInTheFuture(project) || !isPublished(project);
    const notStartedMessage = startingInTheFuture ? 'Du vil kunne stemme når spleisen starter.' : '';
    const status =
        endedMessage || notStartedMessage || 'Velg et alternativ og støtt spleisen med valgfri sum for å stemme';

    return (
        <div className={styles.poll}>
            <div className={styles.header}>
                <Heading1 lookLike={5}>Avstemning: {poll.title}</Heading1>
                <SmallText>{status}</SmallText>
            </div>
            <div className={styles.options}>
                {poll.options.map((option) => (
                    <ProjectPollOption
                        key={option.id}
                        option={option}
                        max={max}
                        countCollectedAmount={poll.count_collected_amount}
                        canVote={!poll.stopped_at && isActive(project)}
                        projectId={project.id}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProjectPoll;
